export const FETCH_COMMISSION_MASTER_DDL = "FETCH_COMMISSION_MASTER_DDL";
export const CREATE_COMMISSION_MASTER = "CREATE_COMMISSION_MASTER";
export const EDIT_COMMISSION_MASTER = "EDIT_COMMISSION_MASTER";
export const DELETE_COMMISSION_MASTER = "DELETE_COMMISSION_MASTER";
